module.exports = __webpack_public_path__ + "static/carebits-movie-banner-adde0afe814fc76f666acf16562741b9.png";